import React from 'react';
import {observer} from 'mobx-react-lite';
import {AccountSwitchScreen} from '../../AccountSwitchScreen';

export default observer(() => {
  return <AccountSwitchScreen goToDashboard={noop} />;
});

const noop = () => {};
